module.exports = __webpack_public_path__ + "img/lunbochanpintouming.eab1f085.png";